var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.title)+" "),_c('help-tooltip',{attrs:{"tooltip":_vm.tooltip}})],1),_c('td',{staticClass:"text-end",class:{'text-warning': _vm.value !== _vm.compareValue}},[_vm._v(_vm._s(_vm.valueText))])])}
var staticRenderFns = []

export { render, staticRenderFns }